module.exports = __webpack_public_path__ + "officialStatic/img/new24.2677a17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new24.jpg
// module id = BPps
// module chunks = 0